import { useCallback, useRef, useState } from 'react';
import { useAudio } from '../../../../../contexts';
import { useMouseMove } from './useMouseMove';
import { useThumbMouseUp } from './useThumbMouseUp';
/**
 * In order to enable element's dragging we need to handle the following steps:
 * 1) Listen to "mouseDown" event which will initiate our dragging flow. (setting "isDragging" state)
 * 2) Register to the document mouse move event in order to update the thumb position accordingly. (only when then above event is fired)
 * 3) Register to the document mouse up event to finish our dragging flow.
 */

export var useThumbDragging = function useThumbDragging(containerRef) {
  var mouseRelativeToThumb = useRef(0);

  var _useState = useState(false),
      isDragging = _useState[0],
      setIsDragging = _useState[1];

  useMouseMove(isDragging, mouseRelativeToThumb, containerRef);
  useThumbMouseUp(setIsDragging);

  var _useAudio = useAudio(),
      pause = _useAudio.pause;
  /**
   * We need to handle the following once the thumb is being clicked for dragging:
   * 1) Keep the distance from the click position till the beginning of the thumb element in order to reduce it for the absolute position of the thumb.
   * 2) Updating the state of "isDragging" so everyone will know we are in dragging mode.
   * 3) Updating the position of the Thumb.
   * 4) Pause the audio.
   */


  var handleMouseDown = useCallback(function (e) {
    if (e.button === 0) {
      // Only for left mouse click
      pause();
      var elem = e.target;

      var _elem$getBoundingClie = elem.getBoundingClientRect(),
          left = _elem$getBoundingClie.left,
          width = _elem$getBoundingClie.width;

      mouseRelativeToThumb.current = e.clientX - left - width / 2; // We need to split the width since the line of the thumb is in the middle

      setIsDragging(true);
    }
  }, [pause, setIsDragging, mouseRelativeToThumb]);
  return {
    handleMouseDown: handleMouseDown
  };
};